export default __webpack_public_path__ + "static/media/sw-word.96bc350d.svg";